import React from 'react'

const DateInput = React.forwardRef((props, ref) => (
  <input
    name='extra'
    className='filters-control' 
    placeholder='MM/DD/YYYY'
    ref={ref}
    value={props.value}
    onClick={props.onClick} 
    onChange={props.onChange}
  />
))

export default DateInput
